import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectDbnpQueryItems } from '../../../../../../redux/dbnp/selector';
import { dbnp } from '../../../../../../redux/dbnp/action';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import DbnpComponent from '../components/dbnp.component';
import PageLoader from '../../../../../../components/PageLoader';

const ManagementDbnp = () => {   
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const dbnpQuery = useSelector(selectDbnpQueryItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectedDbnp,
    setSelectedDbnp
  ] = useState<any>({})
 

  const fetchRouteById= ()=>{
    dispatch(dbnp.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp/query`,entity:'dbnp',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDbnp({ ...selectedDbnp, [field]: event });
  }

  useEffect(
    () => {
        dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{}}))
        .then(()=>{
            if (parmas?.id > 0) {
                fetchRouteById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
           
          })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDbnp(dbnpQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
     dispatch(dbnp.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp`,entity:'dbnp',jsonData:{
          
    Records: [
        selectedDbnp
    ]
 
}})).then(()=>{
    back()
  })
  

    }else{
      dispatch(dbnp.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp`,entity:'dbnp',jsonData:{
          
      Records: [
        selectedDbnp
      ]
    
  }})).then(()=>{
    back()
  })
  
    }
   
    
  }

const back=()=>{
  navigate('/management/organization/dbn/dbnp')
} 

    return (
    <>
     {isLoading ? <PageLoader /> : 
          <DbnpComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDbnp={selectedDbnp}
           back={back}
           handleFormSubmit={handleFormSubmit}
           organizationUnits = {organizationUnitsLists?.result?.items}
          /> 
        } 
          </>
    )
    
    }
   
    export default ManagementDbnp;